import { render, staticRenderFns } from "./quoDetail.vue?vue&type=template&id=3ada619b&scoped=true&"
import script from "./quoDetail.vue?vue&type=script&lang=js&"
export * from "./quoDetail.vue?vue&type=script&lang=js&"
import style0 from "./quoDetail.vue?vue&type=style&index=0&id=3ada619b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada619b",
  null
  
)

export default component.exports